/**
 * Syntax sugar so I don't need to to do `(() => { some code })()`
 */
export function run<T>(fn: () => T) {
    return fn()
}
